import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import {
  Box,
  TextArea,
  FormControl,
  HStack,
  Text,
  WarningOutlineIcon,
} from "native-base";
import InputErrorMessage from "../inputErrorMessage";
import "./style.css";
import { errorMessageIcon } from "../../utils/svg";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE } from "../../utils/fonts";

const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

const NewTextAreaField = forwardRef(
  (
    {
      name = "text",
      value = "",
      label = "",
      width = "auto",
      isInvalid = false,
      isDisabled = false,
      errorMessage = "Enter details",
      placeholder = "",
      onChange = () => {},
      forceRemount,
      basic_details = false,
      speaker = false,
      borderRadius = undefined,
      transparent = false,
      ind = 0,
      setEventBreakError = () => {},
    },
    ref
  ) => {
    const formControlKey = useMemo(() => Date.now(), [forceRemount]);
    const [textAreaValue, setTextAreaValue] = useState({
      value: value !== "" ? value : "",
      name: "",
    });
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
      if (value === "") setTextAreaValue({ value: "" });
      else setTextAreaValue({ value: value });
    }, [forceRemount]);

    useEffect(() => {
      if (speaker) {
        if (value === "") setTextAreaValue({ value: "" });
        else setTextAreaValue({ value: value });
        setShowError(false);
        setEventBreakError(false);
      }
    }, [forceRemount, value]);

    const handleInputChange = (e, name) => {
      let newValue = e.target.value;
      if (
        (name === "speaker_details" || name === "speaker_topic") &&
        newValue !== "" &&
        !/^[^<>~"`{}\\]*$/.test(newValue)
      ) {
        setShowError(true);
        setEventBreakError(true);
        setErrorMsg(
          name === "speaker_details"
            ? `Enter valid About Speaker`
            : `Enter valid Speaker Topic`
        );
        return;
      } else if (
        (name === "speaker_details" || name === "speaker_topic") &&
        newValue !== "" &&
        newValue.length > 5000
      ) {
        setShowError(true);
        setEventBreakError(true);
        setErrorMsg(
          name === "speaker_details"
            ? `Enter About Speaker less than 5000 characters`
            : `Enter Speaker Topic less than 5000 characters`
        );
        return;
      }

      if (
        name !== "agenda" &&
        newValue !== "" &&
        !/^(?!\s)[^<>~"`{}\\]*$/.test(newValue)
      ) {
        return;
      }

      if (
        name === "agenda" &&
        newValue !== "" &&
        !/^(?!\s)[^<>"`{}\\]*$/.test(newValue)
      ) {
        return;
      }

      setShowError(false);
      setEventBreakError(false);
      setTextAreaValue({ value: newValue, name: name });
      onChange(e, name, ind);
    };

    const onSubmitInput = () => {
      return textAreaValue;
    };

    useImperativeHandle(ref, () => ({
      onSubmitInput,
    }));

    return (
      <Box>
        <FormControl
          isInvalid={isInvalid}
          isDisabled={isDisabled}
          w={width}
          key={formControlKey}
        >
          {label && <FormControl.Label>{label}</FormControl.Label>}
          <div
            className={(isInvalid || showError) && "text-area"}
            style={{ overflow: "hidden" }}
          >
            <TextArea
              // defaultValue={value}
              // onChange={(e) => onChange(e, name)}
              {...((isIOS() && basic_details) || speaker
                ? {
                    defaultValue: textAreaValue.value,
                    onBlur: (e) => handleInputChange(e, name),
                  }
                : {
                    value: textAreaValue.value,
                    onChange: (e) => handleInputChange(e, name),
                  })}
              h={40}
              placeholder={placeholder}
              style={{
                fontSize: "14",
                backgroundColor: transparent && "transparent",
                overflow: "auto",
              }}
              borderRadius={borderRadius}
            />
          </div>
          {!showError && isInvalid && (
            <InputErrorMessage errorMessage={errorMessage} />
          )}
          {showError && (
            <HStack space={1} alignItems={"center"} mt={1.5}>
              {/* {errorMessageIcon} */}
              <WarningOutlineIcon size="xs" color="rgb(220, 38, 38)" />
              <Text
                color={COLORS.ERROR_MESSAGE_COLOR}
                fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
              >
                {errorMsg}
              </Text>
            </HStack>
          )}
        </FormControl>
      </Box>
    );
  }
);

export default NewTextAreaField;